import { Form, Heading } from '../../components';
import { useParams, Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { beablooApi } from '../../utils';
import { useState } from 'react';
import { addOptionType } from '../../store/actions/optionTypes';
import { addError } from '../../utils';
import { addNotification } from '../../utils';
import addPending from '../../utils/addPending';
import removePending from '../../utils/removePending';

const CreateOptionType = () => {
  const { categoryId, developmentId } = useParams();
  const [error, setError] = useState([]);
  const [redirect, setRedirect] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  // const socket = useSocket();
  const dispatch = useDispatch();

  const handleSubmit = async (data) => {
    setSaving(true);
    let pendingId = addPending('Saving...');

    const payload = {
      name: data.name,
      categoryId: categoryId,
      image: data.image,
    };

    await beablooApi({
      method: 'POST',
      route: `/developments/${developmentId}/optionTypes/create`,
      payload: payload,
    }).then((r) => {
      removePending(pendingId);
      if (!r.success) {
        setSaving(false);
        addError(r.message);
        setError(r.errors);
      } else {
        // plot saved
        setSaving(false); // stop loading animation
        dispatch(addOptionType(r.data)); // add the plot to state
        setSaved(true);
        addNotification('Option Types has been successfully created.');
        setRedirect(true);
      }
    });
  };

  if (redirect)
    return <Navigate to={`/developments/${developmentId}/optionsOverview`} />;

  return (
    <div className='create-option page-padding'>
      <Heading label={`create an a new option type`} />

      <Form
        errors={error}
        inputs={[
          {
            name: 'name',
            type: 'text',
            label: 'name',
            placeholder: 'Category Name',
          },
          { name: 'image', type: 'single-image', label: 'thumbnail' },
        ]}
        canSubmit={!saving}
        onSubmit={handleSubmit}
        saved={saved}
      />
    </div>
  );
};

export default CreateOptionType;
